module.exports = __webpack_public_path__ + "img/approval1.d12df36e.jpg";